import { AppRestClient } from "@/util/rest/clients/app-rest-client";

import { BizJobTitleModels } from "./bizJobTitle.models";

export namespace BizJobTitleApi {
  export const list = (
    limit: number,
    filter?: BizJobTitleModels.BizJobTitlePaginationFilterDto,
    page?: number,
    cursor?: string,
  ) => {
    return AppRestClient.get(
      { resSchema: BizJobTitleModels.BizJobTitlePaginationResponseDtoSchema },
      `/biz/job-title/list`,
      {
        params: {
          filter,
          limit,
          page,
          cursor,
        },
      },
    );
  };
}
